import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['name', 'input', 'filledIcon', 'emptyIcon', 'placeholder'];

  connect() {
    if (this.inputTarget.files[0]) this.showFileNameAndFilledIcon();
  }

  showFileNameAndFilledIcon(_event) {
    this.placeholderTarget.classList.add('d-none');
    this.emptyIconTarget.classList.add('d-none');
    this.nameTarget.classList.remove('d-none');

    this.nameTarget.textContent = this.inputTarget.files[0].name;
    this.filledIconTarget.classList.remove('d-none');

    this.element.classList.remove('border-gray-200');
    this.element.classList.add('border-primary');
  }
}
